module.exports = "<div id=\"portfolio-app\">\n    <div class=\"content-show-hide\" id=\"page-content\">\n        <div *ngIf=\"errorMsg\">\n            <p>Error: {{errorMsg}}</p>\n        </div>\n        <div class=\"portfolio-item\" *ngFor=\"let item of portfolioItems\">\n            <app-portfolio-item\n                    [project]=\"item\"\n                    [config]=\"config\">\n            </app-portfolio-item>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/portfolio/portfolio.component.html
// module id = ./src/app/portfolio/portfolio.component.html
// module chunks = main